import React from 'react';
import styles from '../styles.module.scss';
import cN from 'classnames';
import { I_FilterItemList, I_FilterOption } from '../interface';
import useShowControl from '../../../../hooks/useShowControl';

import { ArrowUpIcon } from '@features/ui/Icons/index';
import CheckboxItem from './CheckboxItem';

interface I_TransferPointBlockProps {
    title: string;
    showMax: number;
    cols: number;
    transferOptions: I_FilterOption[] | undefined;
    mobileProps?: {
        tempMFilter: I_FilterItemList | null;
        setTempMFilter: Function;
    };
}

// 轉機點
const TransferPointBlock = (props: I_TransferPointBlockProps) => {
    const moduleName = 'filterBlock';
    const { title, showMax, cols, transferOptions, mobileProps } = props;
    const hasOnlySingleChoice = transferOptions?.length === 1;

    const { isOpen, toggle } = useShowControl(true);

    if (hasOnlySingleChoice) return null;
    return (
        <li className={styles[moduleName]}>
            <div className={cN(styles.Block_title)}>
                <div className={cN(styles.Title)}>{title}</div>
            </div>
            <div className={cN(styles.Block_content, { show: true })}>
                <ul className={cN(styles.CheckBoxes)}>
                    {transferOptions?.map((option, i) => {
                        return (
                            <CheckboxItem
                                key={`${option.text + option.value}`}
                                filterType="transferPoint"
                                cols={`col${cols}`}
                                text={option.text}
                                value={option.value}
                                isDisable={option.disable}
                                hide={!isOpen && i > showMax - 1 ? true : false}
                                {...mobileProps}
                            />
                        );
                    })}
                </ul>
            </div>

            {transferOptions && transferOptions?.length > 5 && (
                <div className={cN(styles.Toggle_title)} onClick={toggle}>
                    {`顯示較${isOpen ? '少' : '多'} `}
                    <div className={cN(styles.Icon, { up: isOpen, down: !isOpen })}>
                        <ArrowUpIcon fill="#0077b3" />
                    </div>
                </div>
            )}
        </li>
    );
};

export default TransferPointBlock;
